import React, { useRef, useState, useCallback } from 'react';

const ImageCarousel = ({ images }) => {
  const trackRef = useRef(null);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const handleScroll = (direction) => {
    const track = trackRef.current;
    if (!track) return;
    const firstCard = track.querySelector('.carousel-item');
    const cardWidth = firstCard ? firstCard.clientWidth : track.clientWidth;
    const gap = 16; // must match CSS gap
    const offset = cardWidth + gap;
    track.scrollBy({ left: direction * offset, behavior: 'smooth' });
  };

  const openLightbox = useCallback((index) => setLightboxIndex(index), []);
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);

  return (
    <div className="carousel">
      <button
        type="button"
        className="carousel-nav prev"
        aria-label="Anterior"
        onClick={() => handleScroll(-1)}
      >
        ‹
      </button>
      <div className="carousel-track" ref={trackRef}>
        {images.map((img, index) => (
          <div className="carousel-item" key={index}>
            <button type="button" className="carousel-img-btn" onClick={() => openLightbox(index)}>
              <img className="carousel-img" src={img.src} alt={img.alt || `Imagen ${index + 1}`} />
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        className="carousel-nav next"
        aria-label="Siguiente"
        onClick={() => handleScroll(1)}
      >
        ›
      </button>

      {lightboxIndex !== null && images[lightboxIndex] && (
        <div className="lightbox" role="dialog" aria-modal="true" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="lightbox-close" onClick={closeLightbox} aria-label="Cerrar">×</button>
            <img
              className="lightbox-img"
              src={images[lightboxIndex].src}
              alt={images[lightboxIndex].alt || `Imagen ${lightboxIndex + 1}`}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;


